import { useState } from 'react'

import { EMPTY_LIST } from '../../../../constants/common'
import { useNotification } from '../../../../hooks'
import { parseServerValidation } from '../../../../utils/validation'
import {
  addNewContact,
  getAreNewContactsFilled,
  getNewContactsInitialValues,
  getProfileContactsWidgetErrorNotificationKey,
  removeContactById,
  removeContactsByIds,
} from '../ProfileContactsWidget.utils'
import {
  PROFILE_CONTACTS_WIDGET_NOTIFICATION_KEY,
  PROFILE_CONTACTS_WIDGET_VALUE_FIELD,
} from '../ProfileContactsWidgetListCell'

export function useProfileContactsWidgetCreateForm({ api, onCreated }) {
  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  const [newContacts, setNewContacts] = useState(EMPTY_LIST)

  const initialValues = getNewContactsInitialValues(newContacts)

  function handleSelectItem(item) {
    setNewContacts(prev =>
      addNewContact({ newContacts: prev, typeConfig: item.typeConfig })
    )
  }

  function handleRemoveContact(contactId) {
    setNewContacts(prev => removeContactById({ contactId, newContacts: prev }))
  }

  function handleCancelCreate() {
    setNewContacts(EMPTY_LIST)
  }

  async function createNewContacts({ savedContactIds, values }) {
    for (const contact of newContacts) {
      await api.create({
        typeConfig: contact.typeConfig,
        value: values[contact.id][PROFILE_CONTACTS_WIDGET_VALUE_FIELD],
      })

      savedContactIds.push(contact.id)
    }
  }

  async function handleCreateSubmit(values, { setErrors }) {
    if (getAreNewContactsFilled({ newContacts, values })) {
      const savedContactIds = []

      return createNewContacts({ savedContactIds, values })
        .then(() => {
          onCreated()
          setNewContacts(EMPTY_LIST)
          handleAddSuccessNotification(
            PROFILE_CONTACTS_WIDGET_NOTIFICATION_KEY.saved
          )
        })
        .catch(error => {
          if (savedContactIds.length > 0) {
            onCreated()
            setNewContacts(prev =>
              removeContactsByIds({
                contactIds: savedContactIds,
                newContacts: prev,
              })
            )
          }

          setErrors(parseServerValidation(error))
          handleAddErrorNotification(
            getProfileContactsWidgetErrorNotificationKey(error)
          )
        })
    }
  }

  return {
    handleCancelCreate,
    handleCreateSubmit,
    handleRemoveContact,
    handleSelectItem,
    initialValues,
    newContacts,
  }
}
